import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Spanish } from 'flatpickr/dist/l10n/es.js';
// Connects to data-controller="flatpickr"
export default class extends Controller {
  static targets = ["calendario"];
  static values = {
    fechas: Array,
    totales: Array,
    baseurl: String,
  };
  
  connect() {
    this.updateArraySpanish();
    this.initializeFlatpickr();
  }

  updateArraySpanish() {
    const fechas = this.totalesValue;
    const arraySpanish = [];
    
    fechas.forEach((fecha) => {
      const fechaString = fecha.split('T')[0];
      const [year, month, day] = fechaString.split('-');
      const fechaNueva = new Date(year, parseInt(month) - 1, parseInt(day));
      const opcionesFecha = { month: "long", day: "numeric", year: "numeric" };
      const [dayEs, monthEs, yearEs] = fechaNueva.toLocaleDateString("es-ES", opcionesFecha).split(" de ");
      const formattedDate = `${monthEs.charAt(0).toUpperCase() + monthEs.slice(1)} ${dayEs.replace(',', '')}, ${yearEs}`;
      arraySpanish.push(formattedDate);
    });
    
    this.arraySpanish = arraySpanish;
    console.log('📅 arraySpanish actualizado:', this.arraySpanish.length, 'fechas');
  }

  initializeFlatpickr() {
    console.log('baseurl',this.baseurlValue)
    const burl = this.baseurlValue;
    const arraySpanish = this.arraySpanish;
    
    const urlParams = new URLSearchParams(window.location.search);
    const fechaSeleccionada = urlParams.get('fecha');
    
    if (!this.flatpickrInstance) {
      this.flatpickrInstance = flatpickr(this.element, {
        enableTime: false,
        inline: true,
        locale: Spanish,
        dateFormat: "Y-m-d",
        defaultDate: fechaSeleccionada,
        onDayCreate: function (dObj, dStr, fp, dayElem) {
          dayElem.addEventListener("click", function (event) {
            event.preventDefault();
            const meses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            const mes = meses[dayElem.dateObj.getUTCMonth()];
            const dia = dayElem.dateObj.getDate();
            const año = dayElem.dateObj.getFullYear();
            const fecha = `${año}-${mes}-${dia}`;

            if (
              window.location.hostname === "localhost" ||
              window.location.hostname === "127.0.0.1"
            ) {
              var baseUrl = "http://localhost:3000";
            } else {
              var baseUrl = burl;
            }
            window.location.href = `${baseUrl}/portal_pacientes/calendario/${fecha}`;
          });
        },
        onMonthChange: function (selectedDates, dateStr, instance) {
          const mesNuevo = instance.currentMonth;
          const añoNuevo = instance.currentYear;
          
          const hoyReal = new Date();
          const esMesActual = (mesNuevo === hoyReal.getMonth() && añoNuevo === hoyReal.getFullYear());

          let fechaDefecto;
          let nuevaFechaObj;

          if (esMesActual) {
            nuevaFechaObj = hoyReal;
            fechaDefecto = `${hoyReal.getFullYear()}-${hoyReal.getMonth() + 1}-${hoyReal.getDate()}`;
          } else {
            nuevaFechaObj = new Date(añoNuevo, mesNuevo, 1);
            fechaDefecto = `${añoNuevo}-${mesNuevo + 1}-1`;
          }
          
          instance.setDate(nuevaFechaObj, false);

          const baseUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
            ? "http://localhost:3000"
            : burl;

          const urlDestino = `${baseUrl}/portal_pacientes/calendario/${fechaDefecto}`;

          const frame = document.getElementById("tarjetas_visitas");
          if (frame) {
            frame.src = urlDestino;
          }

          // Volvemos a pintar los puntitos destacados
          setTimeout(() => {
            const calendarContainer = instance.calendarContainer;
            const days = calendarContainer.querySelectorAll(".flatpickr-day");
            days.forEach(function (day) {
              const fecha = day.getAttribute("aria-label");
              if (fecha && arraySpanish.includes(fecha)) {
                day.classList.add("destacado");
              }
            });
          }, 10);
        },
        onReady: function (selectedDates, dateStr, instance) {
          const calendarContainer = instance.calendarContainer;
          const days = calendarContainer.querySelectorAll(".flatpickr-day");
          console.log('🚀 Calendar ready. Checking', days.length, 'days. arraySpanish has', arraySpanish.length, 'dates');
          days.forEach(function (day) {
            const fecha = day.getAttribute("aria-label");
            if (fecha && arraySpanish.includes(fecha)) {
              console.log('✅ Match found (onReady):', fecha);
              day.classList.add("destacado");
            }
          });
        },
        onChange: function (selectedDates, dateStr, instance) {
          const calendarContainer = instance.calendarContainer;
          const days = calendarContainer.querySelectorAll(".flatpickr-day");
          console.log('📝 Date changed. Checking', days.length, 'days. arraySpanish has', arraySpanish.length, 'dates');
          days.forEach(function (day) {
            const fecha = day.getAttribute("aria-label");
            if (fecha && arraySpanish.includes(fecha)) {
              console.log('✅ Match found (onChange):', fecha);
              day.classList.add("destacado");
            }
          });
        },
      });
    }
  }

  disconnect() {
    // Destruye la instancia de Flatpickr al desconectar el controlador
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }
}

// Listener para cuando el Turbo frame termina de cargar
document.addEventListener('turbo:frame-load', function(event) {
  if (event.target.id === 'tarjetas_visitas') {
    console.log('📥 Frame cargado, actualizando arraySpanish');
    // El input sigue existiendo fuera del frame, actualiza arraySpanish
    const inputElement = document.getElementById('fecha');
    if (inputElement) {
      try {
        const application = Stimulus.application;
        const controller = application.getControllerForElementAndIdentifier(inputElement, 'flatpickr-paciente');
        
        if (controller) {
          controller.updateArraySpanish();
          
          // Repinta los destacados con los nuevos datos
          setTimeout(() => {
            if (controller.flatpickrInstance) {
              const instance = controller.flatpickrInstance;
              const calendarContainer = instance.calendarContainer;
              const days = calendarContainer.querySelectorAll(".flatpickr-day");
              console.log('✅ Reabilitando destacados, arraySpanish tiene', controller.arraySpanish.length, 'fechas');
              days.forEach(function (day) {
                const fecha = day.getAttribute("aria-label");
                if (fecha && controller.arraySpanish.includes(fecha)) {
                  day.classList.add("destacado");
                }
              });
            }
          }, 100);
        }
      } catch (err) {
        console.error('❌ Error actualizando arraySpanish:', err);
      }
    }
  }
});
